import React, { useContext, useReducer, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment-with-locales-es6'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { getStationConfigurationLocals, getStationsConfigurations } from '../../services/Stations'

import Footer from '../../components/Footer'
import withLang from '../../withLang'
import SelectStation from './SelectStation'
import SelectDate from './selectDate'
import Loading from '../../components/Loading'
import { useDisableBodyScroll } from '../../utils/useDisableBodyScroll'

function reducer(state, action) {
  switch (action.type) {

    case 'FIELD':
      return { ...state, [action.payload.field]: action.payload.value }

    case 'SELECT_STATION':
      return { ...state, pickupStationId: action.payload, openSelectStation: false }

    case 'SELECT_DATE':
      return { ...state, pickupDate: action.payload, openSelectDate: false }

    case 'SET_VALIDATIONS':
      return { ...state, loading: true, validateInputs: true };

    case 'TOGGLE_VALIDATIONS':
      return { ...state, loading: !state.loading, validateInputs: !state.validateInputs };

    case 'SET_CAN_NEXT':
      return { ...state, loading: false, canNext: action.payload };

    default:
      return state;
  }
}

const initialState = {
  pickupStationId: '',
  pickupDate: '',

  openSelectStation: false,
  openSelectDate: false,

  stations: [],

  loading: false,
  canNext: false,
  validateInputs: false,
}

function SelectPickupDetailsPage(props) {
  const { t, i18n } = useTranslation()

  const { setKioskCurrentStationId, setPickupDate, language } = useContext(DomainContext)

  const [state, dispatch] = useReducer(reducer, initialState, (arg) => {
    return {
      ...arg,
    }
  })

  const { pickupStationId, pickupDate, loading, canNext, stations, openSelectStation, openSelectDate, validateInputs } = state

  useDisableBodyScroll(openSelectStation || openSelectDate)

  useEffect(() => {
    const func = async () => {
      dispatch({ type: 'FIELD', payload: { field: 'loading', value: true } })

      const stationsRes = (await getStationsConfigurations()).stationsConfigurations

      const stationsDetailed = await Promise.all(stationsRes.map(async s => {
        const label = t(s.name) || pickupStationId
        return { ...s, label }
      }))

      dispatch({ type: 'FIELD', payload: { field: 'loading', value: false } })

      dispatch({ type: 'FIELD', payload: { field: 'stations', value: stationsDetailed } })

      if (stations.length === 1) {
        dispatch({ type: 'FIELD', payload: { field: 'pickupStationId', value: stationsDetailed[0].stationId } })
      }
    }

    func()
  }, [])

  useEffect(() => {
    if (validateInputs) {
      dispatch({ type: 'TOGGLE_VALIDATIONS' })

      const validStation = !!pickupStationId
      const validDate = !!pickupDate

      if (validDate && validStation) {
        dispatch({ type: 'SET_CAN_NEXT', payload: true })
      }
    }
  }, [validateInputs])

  useEffect(() => {
    if (canNext) {
      setKioskCurrentStationId(pickupStationId)
      setPickupDate(pickupDate)
      props.history.push('/input-reservation-ref')
    }
  }, [canNext])

  function handleNextClick() {
    dispatch({ type: 'SET_VALIDATIONS' })
  }

  function handleStationClick(station) {
    dispatch({ type: 'SELECT_STATION', payload: station.stationId })
  }

  function handleDateClick(date) {
    const formattedDate = date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : ''
    if (moment(formattedDate, 'YYYY-MM-DD').isValid()) {
      dispatch({ type: 'SELECT_DATE', payload: formattedDate })
    } else {
      dispatch({ type: 'SELECT_DATE', payload: '' })
    }
  }

  function displayDate() {
    return pickupDate ? moment(pickupDate, 'YYYY-MM-DD').locale(i18n.language).format('DD MMMM YYYY') : ''
  }

  function displayStationName() {
    const station = stations.find(s => s.stationId === pickupStationId)
    return station ? station.label : pickupStationId
  }

  return (
    <main className='page-layout'>
      <div className="container grow">
        <div className="row">
          <div className="col-3">
            <div onClick={() => props.history.push('/start')}>
              <img src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
            </div>
          </div>
        </div>

        <div className="main-frame">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 mb-5">
                <h2 className="title color-grey">
                  {t('selectPickupStation1')}<br />{t('selectPickupStation2')}
                </h2>
              </div>
              <div className="board-background w-100 row justify-content-center">
                <div className="col-md-6 col-sm-8">
                  <div className={`btn btn-green w-100 px-5 py-2 my-1 map-pin enebled ${pickupStationId ? 'done' : ''}`} onClick={() => dispatch({ type: 'FIELD', payload: { field: 'openSelectStation', value: true } })}>
                    {pickupStationId ? displayStationName() : t('selectPickupStation')}
                  </div>
                </div>
                <div className="col-md-6 col-sm-8">
                  <div className={`btn btn-green w-100 px-5 py-2 my-1 calendar ${!pickupStationId ? 'disabled' : ''} ${pickupDate ? 'done' : ''} ${!pickupStationId ? 'disabled' : ''}`} onClick={() => pickupStationId && dispatch({ type: 'FIELD', payload: { field: 'openSelectDate', value: true } })}>
                    {pickupDate ? displayDate() : t('selectPickupDate')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer
        nextDisabled={!pickupStationId || !pickupDate}
        handlePrevClick={() => props.history.goBack()}
        handleNextClick={handleNextClick}
      />
      {openSelectStation &&
        <SelectStation
          t={t}
          handleClose={() => dispatch({ type: 'FIELD', payload: { field: 'openSelectStation', value: false } })}
          stations={stations}
          handleStationClick={handleStationClick}
        />
      }
      {openSelectDate &&
        <SelectDate
          t={t}
          handleClose={() => dispatch({ type: 'FIELD', payload: { field: 'openSelectDate', value: false } })}
          handleDateClick={handleDateClick}
          language={language}
        />
      }
    </main>
  )
}

export default withLang(SelectPickupDetailsPage)

